import React, { useContext, useState } from 'react';
import UploadButton from '../../../../common/components/upload_button';
import { MainContext } from './contexts';

const ImageEditor = () => {
  const { data, allowedTypes, setImageData } = useContext(MainContext);
  const [ loading, setLoading ] = useState(false);
  const [ imageSrc, setImageSrc ] = useState(data.image_src || '');

  const handleStartUpload = () => {
    setLoading(true);
  };

  const handleFinishUpload = (files) => {
    const [ file ] = files;
    setImageData(file.metaData);
    setImageSrc(file.previewSrc);
    setLoading(false);
  };

  const handleDeleteImage = () => {
    setImageData('{}');
    setImageSrc(null);
  };

  return (
    <div className="form_section">
      <div className="form_section-title -grid">
        <div className="form_section-title-item">
          <h3>Product Image</h3>
        </div>
      </div>
      <div className="form-upload">
        {
          !imageSrc &&
          <div className="file-uploader">
            <UploadButton
              className="button -secondary file-uploader_control form-upload_button -white-back"
              allowedTypes={ allowedTypes }
              onInit={ handleStartUpload }
              onUploaded={ handleFinishUpload }
              needPreview
              customProcessingTitle="Uploading..."
            >
              Upload...
            </UploadButton>
          </div>
        }
        {
          !!imageSrc &&
          <div className="form-upload_grid">
            { loading && <div className="page-loader -inner-loader" /> }
            <div className="form-upload_grid-item">
              <div className="form-upload_preview-single-image">
                <img src={ imageSrc } id="preview-image" alt="product-image" />
              </div>
            </div>
            <div className="form-upload_grid-item -buttons">
              <div className="form-upload_button-block">
                <button
                  className="button -secondary -block -white-back"
                  onClick={ handleDeleteImage }
                >
                  <svg className="icon -i-delete button_icon -delete">
                    <use xlinkHref="#svg_i-delete" />
                  </svg>
                  <span className="button_text">Delete</span>
                </button>
              </div>
              <div className="form-upload_button-block">
                <div className="file-uploader">
                  <UploadButton
                    className="button -secondary -block file-uploader_control -white-back"
                    allowedTypes={ allowedTypes }
                    onInit={ handleStartUpload }
                    onUploaded={ handleFinishUpload }
                    needPreview
                    customProcessingTitle="Uploading..."
                  >
                    Upload new...
                  </UploadButton>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default ImageEditor;
